import React from 'react'
import NumberFormat from 'react-number-format'
import { TextField } from '@material-ui/core'

const NumericInput = ({ field, form: { touched, errors }, ...props }) => {
  let touchedValue = null
  let errorValue = null
  let fieldNameArray = field.name.split('.')
  if (fieldNameArray.length > 1) {
    touchedValue =
      touched[fieldNameArray[0]] &&
      touched[fieldNameArray[0]][fieldNameArray[1]]

    errorValue =
      errors[fieldNameArray[0]] && errors[fieldNameArray[0]][fieldNameArray[1]]
  } else {
    touchedValue = touched[fieldNameArray[0]]
    errorValue = errors[fieldNameArray[0]]
  }
  return (
    <NumberFormat
      error={touchedValue && errorValue ? true : false}
      helperText={touchedValue && errorValue && `${errorValue}`}
      customInput={TextField}
      {...field}
      {...props}
    />
  )
}
export default NumericInput
